import React from "react"
import PropTypes from "prop-types"
import { Button, FormGroup, Radio } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment";
import { ChargeCalculationType, ChargeTimeType, getChargeAmount } from '../../lib/utils'
import FontAwesome from "react-fontawesome"
import Authenticated from "../../lib/Authenticated"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../lib/blockingFetch"
import SimpleCardRow from "../fragments/SimpleCardRow"
import FixRecordingInFineract from "../fragments/FixRecordingInFineract"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

class ChargeCard extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    runningFix: false,
    fixDone: false,
    error: null,
  }

  resubmitChargeInFineract = chargeId => {

    this.setState({
      runningFix: true,
      fixDone: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.triggerChargeRecording(accessToken, chargeId),
      _ => this.setState({ fixDone: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningFix: false })
    )
  }

  checkChargeRecording = charge => {

    const { fixDone, runningFix, error } = this.state
    if(charge.fineractId !== 0 || fixDone || !this.isAdmin) return null
    return <FixRecordingInFineract
      running={ runningFix } error={ error }
      onClick={() => this.resubmitChargeInFineract(charge.id)}
    />
  }

  renderActiveField = active =>
    <Row>
      <Col xs={3}><strong>Status</strong></Col>
      <Col xs={9}>
        <FormGroup>
          <Radio readOnly name="status" inline checked={ active }>
            Active
          </Radio>{' '}
          <Radio readOnly name="status" inline checked={ !active }>
            Inactive
          </Radio>
        </FormGroup>
        <hr/>
      </Col>
    </Row>

  showRow = (name, value) => <SimpleCardRow name={ name } value={ value } />

  renderButtonToolbar = chargeId => {

    if(!this.isAdmin) return null
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/charges/${chargeId}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button> &nbsp;

        <Button bsStyle="success" onClick={() => browserHistory.push('/charges/create')}>
          <FontAwesome name='plus-circle' /> New Charge
        </Button>
      </div>
    )
  }

  showCharge = charge => {

    if(!charge) return null
    const { id: chargeId, active, name, currencyCode, chargeTimeType, chargeCalculationType,
      amount, createdOn } = charge

    return (
      <Col md={8} className='detail-content'>

        { this.checkChargeRecording(charge) }

        <h2 className="blue">{ name }</h2>

        { this.renderActiveField(active) }

        { this.showRow('Currency Code', currencyCode) }

        { this.showRow('Charge Time Type', ChargeTimeType[chargeTimeType]) }

        { this.showRow('Charge Calculation Type', ChargeCalculationType[chargeCalculationType]) }

        { this.showRow('Amount', getChargeAmount({ amount, chargeCalculationType, currencyCode })) }

        <SimpleCardRow name='Created On' value={ createdOn ? moment(createdOn).format('lll') : '' }
          className='gray font-size-13' />  

        { this.renderButtonToolbar(chargeId) }

      </Col>
    )
  }

  render() {
    const { charge } = this.props
    const data = [{ url: '/charges', title: 'Charges' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ charge.name } data={ data } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="thumb-tack" size="3x" className="detail-icon" />
          </Col>

          { this.showCharge(charge) }
        </Row>
      </div>
    )
  }
}

ChargeCard.propTypes = {
  charge: PropTypes.object.isRequired,
}

export default ChargeCard



// WEBPACK FOOTER //
// ./src/components/Charges/ChargeCard.js